import _ from 'lodash'
const siteHeaderConfig = {
    el: _.select( '.header__main' ),
    treshold: 100,
    breakpoint: 0,
    subnavs: _.selectAll( '.header__main .subnav' ),
    subnavHamburger: _.select( '.header__main .site__hamburger' ),
    mobileHamburger: _.select( '.header__main .mobile__hamburger' )
}

export default siteHeaderConfig